import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService, GenericError } from '@auth0/auth0-angular';
import { filter, mergeMap } from 'rxjs';
@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'b2frontend';
    private authService = inject(AuthService);

    constructor() {
        this.authService.error$
            .pipe(
                filter(
                    e =>
                        e instanceof GenericError &&
                        (e.error === 'login_required' ||
                            e.error === 'invalid_grant' ||
                            e.error === 'missing_refresh_token')
                ),
                mergeMap(() => this.authService.loginWithRedirect())
            )
            .subscribe();
    }
}
